import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import ModalReportLicenseDispute from '../../../modals/ModalReportLicenseDispute';
import useCreateLicenseDispute from '../../hooks/useCreateLicenseDispute';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import type { LicensingIssue } from '../../../../../shared/issuesV2';
import type { LicenseDisputeReasonsType } from '../../../../../shared/model-typings/licensedisputes';

import styles from '../DisputeFooter.module.less';

const LicenseIssueDisputeFooter: VoidFunctionComponent = () => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails) as LicensingIssue;
  const { licenseDisputeModal, isAnyModalOpen } = useIssueDetailsModals();

  const {
    onCreateLicenseDispute,
    onResetErrors,
    createLicenseDisputeErrors,
    isCreating,
  } = useCreateLicenseDispute();

  const onSubmit = async (comment: string, reason: LicenseDisputeReasonsType) => {
    onResetErrors();
    await onCreateLicenseDispute(issueDetails.id, { comment, reason }, licenseDisputeModal.onClose);
  };

  return (
    <>
      <footer className={styles.footer}>
        Found a mistake?
        {' '}
        <button
          type="button"
          className={styles.footerButton}
          onClick={() => !isAnyModalOpen && licenseDisputeModal.onOpen()}
          disabled={isAnyModalOpen}
        >
          Report a data issue with this license.
        </button>
      </footer>
      <ModalReportLicenseDispute
        errors={createLicenseDisputeErrors || []}
        isCreating={isCreating}
        onHide={licenseDisputeModal.onClose}
        onSubmit={onSubmit}
        show={licenseDisputeModal.isOpen}
      />
    </>
  );
};

export default LicenseIssueDisputeFooter;
